export default __webpack_public_path__ + "static/media/final_img.45b93c50.webp";